import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  //selector: 'dialog-content-example-dialog',
  selector: 'needs-kit-modal',
  standalone : true,
  templateUrl: 'needsVenous.modal.html',
  imports: [
    MatDialogModule
  ]
})
export class NeedsVenousModal { }
